import { cellErrorDescription } from './cellErrorDescription'
import { OUTCOME_TEXT, PROBLEM_TEXT } from '../qr/labelPrinting/labelPrintingTexts'

// Historia 226, E19: Sun sends the reason an unavailable label printer is down as the printer's own code, followed by its
// problems when it has some ("PRINTER_NOT_READY [PAPER_OUT, HEAD_OPEN]"); the reader sees it in their language, with the
// same keys the printers screen uses. Only this alarm: the data of every other one are interpolated as they come (RN-T5).
const PRINTER_REASON = /^([A-Z_]+)(?: \[(.*)\])?$/
const printerReasonText = (t_, reason) => {
  const match = typeof reason === 'string' ? reason.match(PRINTER_REASON) : null
  if (!match || !OUTCOME_TEXT[match[1]]) return reason
  const problems = (match[2] || '').split(',').map((problem) => problem.trim()).filter(Boolean)
    .map((problem) => t_(PROBLEM_TEXT[problem] || problem))
  return problems.length > 0 ? `${t_(OUTCOME_TEXT[match[1]])} (${problems.join(', ')})` : t_(OUTCOME_TEXT[match[1]])
}
const PARAM_TRANSLATORS = { LABEL_PRINTER_UNAVAILABLE_DESCRIPTION: { reason: printerReasonText } }

// Story 204 — RN3.7: the description of an alarm in the user's language. An alarm Sun composed arrives with
// `descriptionCode` + `descriptionParams` (C3) and is translated by that code with its data interpolated as they are
// (RN-T5), the English `description` being the fallback when no language has the key. Everything else (alarms stored
// before the story, machine/driver/PLC texts) keeps story 162's rule: the cell's PLC codes by key, the rest verbatim.
const alarmDescription = (t_, alarm) => {
  const descriptionCode = typeof alarm?.descriptionCode === 'string' ? alarm.descriptionCode : ''
  if (descriptionCode === '') return cellErrorDescription(t_, alarm)
  const description = typeof alarm.description === 'string' ? alarm.description : ''
  const params = alarm.descriptionParams && typeof alarm.descriptionParams === 'object' ? alarm.descriptionParams : {}
  const translators = PARAM_TRANSLATORS[descriptionCode] || {}
  const shown = Object.keys(params).reduce((acc, name) => ({ ...acc, [name]: translators[name] ? translators[name](t_, params[name]) : params[name] }), {})
  return t_(descriptionCode, { ...shown, defaultValue: description })
}

export { alarmDescription }
